import { GVA_API_URL } from '../config/serviceConfig';

/**
 * 机构定制 Logo：相对路径拼 GVA 地址；空则默认墨子头像。
 * 供顶栏、群聊展示模式等共用，避免各处写死 /avatars/mozi.png。
 */
export function resolveBrandLogoUrl(logoUrl) {
  if (!logoUrl) {
    return '/avatars/mozi.png';
  }
  if (
    logoUrl.startsWith('http://') ||
    logoUrl.startsWith('https://') ||
    logoUrl.startsWith('data:') ||
    logoUrl.startsWith('/avatars/')
  ) {
    return logoUrl;
  }
  const base = String(GVA_API_URL || '').replace(/\/$/, '');
  const path = logoUrl.startsWith('/') ? logoUrl : `/${logoUrl}`;
  return `${base}${path}`;
}
